module.exports = __webpack_public_path__ + "img/icon-vocabulario.bac3e9ae.svg";